// import React, { useState, useEffect } from "react";
// import { apiCall } from "../Apis/apiCall";
// import { useNavigate } from "react-router-dom";
// import Select from "react-select";
// import LoadingComponent from "./ui/LoadingComponent";
// import { handleApiResponse, handleCustomResponse } from "../utils/response";
// import CustomSelect from "./ui/CustomSelect";

// const WorkFlowAssignListLayer = () => {
//   const navigate = useNavigate();

//   // Client state
//   const [allClients, setAllClients] = useState([]);
//   const [clients, setClients] = useState([]);
//   const [clientsLoading, setClientsLoading] = useState(false);
//   const [clientSearch, setClientSearch] = useState("");
//   const [selectedClient, setSelectedClient] = useState(null);

//   // Workflow state
//   const [allWorkflows, setAllWorkflows] = useState([]);
//   const [workflows, setWorkflows] = useState([]);
//   const [workflowsLoading, setWorkflowsLoading] = useState(false);
//   const [workflowSearch, setWorkflowSearch] = useState("");
//   const [selectedWorkflows, setSelectedWorkflows] = useState([]);

//   // Assignment state
//   const [assignLoading, setAssignLoading] = useState(false);
//   const [pageLoading, setPageLoading] = useState(true);

//   // Fetch clients (only initial load)
//   const fetchClients = async () => {
//     try {
//       setClientsLoading(true);
//       const endpoint = `/get-all-clients?search=&page=1&per_page=1000&sort_by=client_id&sort_order=desc&want_pagination=0`;

//       const response = await apiCall("get", endpoint, null, navigate);

//       if (response?.data?.success) {
//         const clientList = response.data.data || [];
//         setAllClients(clientList);
//         setClients(clientList);

//         const handleRes = response.data;
//         handleApiResponse(handleRes, "success", "GET");
//       } else {
//         handleCustomResponse("error", "Failed to fetch clients");
//       }
//     } catch (error) {
//       const handleErr = error.response?.data;
//       handleApiResponse(handleErr, "Err", "GET");
//     } finally {
//       setClientsLoading(false);
//     }
//   };

//   // Fetch workflows (only initial load)
//   const fetchWorkflows = async () => {
//     try {
//       setWorkflowsLoading(true);
//       const endpoint = `/get-all-workflows-bo?search=&page=1&per_page=1000&sort_by=workflow_id&sort_order=desc&want_pagination=0`;

//       const response = await apiCall("get", endpoint, null, navigate);

//       if (response?.data?.errorCode === 0) {
//         const { data: workflowData } = response.data;

//         const mappedWorkflows = workflowData.map((workflow) => ({
//           id: workflow.workflow_id,
//           name: workflow.workflow_name,
//           description: workflow.description || "",
//         }));
//         setAllWorkflows(mappedWorkflows);
//         setWorkflows(mappedWorkflows);
//         const handleRes = response.data;
//         handleApiResponse(handleRes, "success", "GET");
//       } else {
//         handleCustomResponse("error", "Failed to fetch workflows");
//       }
//     } catch (error) {
//       const handleErr = error.response?.data;
//       handleApiResponse(handleErr, "Err", "GET");
//     } finally {
//       setWorkflowsLoading(false);
//     }
//   };

//   // Initial load
//   useEffect(() => {
//     const loadInitialData = async () => {
//       setPageLoading(true);
//       await Promise.all([fetchClients(), fetchWorkflows()]);
//       setPageLoading(false);
//     };

//     loadInitialData();
//   }, []);

//   // Local client search handler
//   const handleClientSearch = (value) => {
//     setClientSearch(value);

//     if (!value.trim()) {
//       setClients(allClients);
//       return;
//     }

//     const filtered = allClients.filter((client) =>
//       (client.client_name || client.name || "")
//         .toLowerCase()
//         .includes(value.toLowerCase())
//     );
//     setClients(filtered);
//   };

//   // Local workflow search handler
//   const handleWorkflowSearch = (value) => {
//     setWorkflowSearch(value);

//     if (!value.trim()) {
//       setWorkflows(allWorkflows);
//       return;
//     }

//     const filtered = allWorkflows.filter((workflow) =>
//       workflow.name.toLowerCase().includes(value.toLowerCase())
//     );
//     setWorkflows(filtered);
//   };

//   // Client select handler
//   const handleClientSelect = (selectedOption) => {
//     const client = clients.find((c) => c.client_id === selectedOption?.value);
//     setSelectedClient(client);
//   };

//   // Workflow select handler
//   const handleWorkflowSelect = (selectedOptions) => {
//     const selected = selectedOptions
//       ? selectedOptions.map((option) => ({
//           id: option.value,
//           name: option.label,
//         }))
//       : [];
//     setSelectedWorkflows(selected);
//   };

//   // Toggle workflow for badge removal
//   const handleWorkflowToggle = (workflow) => {
//     setSelectedWorkflows((prev) => {
//       const exists = prev.find((w) => w.id === workflow.id);
//       if (exists) {
//         return prev.filter((w) => w.id !== workflow.id);
//       } else {
//         return [...prev, workflow];
//       }
//     });
//   };

//   // Assign workflows
//   const handleAssignWorkflows = async (e) => {
//     e.preventDefault();

//     if (!selectedClient) {
//       handleCustomResponse("error", "Please select a client");
//       return;
//     }

//     if (selectedWorkflows.length === 0) {
//       handleCustomResponse("error", "Please select at least one workflow");
//       return;
//     }

//     try {
//       setAssignLoading(true);

//       const payload = {
//         client_id: selectedClient.client_id,
//         workflow_ids: selectedWorkflows.map((w) => w.id),
//       };

//       const response = await apiCall(
//         "POST",
//         "/assign-workflows",
//         payload,
//         navigate
//       );

//       if (response.data?.success) {
//         const handleRes = response.data;
//         handleApiResponse(handleRes, "success", "POST");

//         // Reset form
//         setSelectedClient(null);
//         setSelectedWorkflows([]);

//         // Navigate to workflow list after successful assignment
//         setTimeout(() => {
//           navigate("/workflow-assign");
//         }, 1500);
//       } else {
//         handleCustomResponse("error", "Failed to assign workflows");
//       }
//     } catch (error) {
//       const handleErr = error.response?.data;
//       handleApiResponse(handleErr, "Err", "POST");
//     } finally {
//       setAssignLoading(false);
//     }
//   };

//   // Client options
//   const getClientOptions = () => {
//     return clients.map((client) => ({
//       value: client.client_id,
//       label: client.client_name || client.name,
//     }));
//   };

//   // Workflow options
//   const getWorkflowOptions = () => {
//     return workflows.map((workflow) => ({
//       value: workflow.id,
//       label: workflow.name,
//     }));
//   };

//   // Show loading component while initial data loads
//   if (pageLoading) {
//     return <LoadingComponent />;
//   }

//   const clientOptions = getClientOptions();
//   const workflowOptions = getWorkflowOptions();

//   return (
//     <div className="p-4 p-md-3 p-sm-2">
//       <div className="card shadow-sm">
//         <div className="card p-3 p-sm-2 p-md-3">
//           <form onSubmit={handleAssignWorkflows}>
//             <div className="row g-20">
//               {/* Client Selection */}
//               <div className="col-md-6 mb-20">
//                 <label className="form-label fw-semibold text-primary-light text-sm mb-8">
//                   Select Client <span className="text-danger-600">*</span>
//                 </label>
//                 <CustomSelect
//   name="client"
//   value={selectedClient ? {
//     value: selectedClient.client_id,
//     label: selectedClient.client_name || selectedClient.name,
//   } : null}
//   onChange={handleClientSelect}
//   options={clients}
//   placeholder="Search and select client..."
//   labelKey="client_name"
//   valueKey="client_id"
//   addNewLabel="Add New Client"
//   addNewRoute="/add-client"
//   isLoading={clientsLoading}
// />
//               </div>

//               {/* Workflow Selection */}
//               <div className="col-md-6 mb-20">
//                 <label className="form-label fw-semibold text-primary-light text-sm mb-8">
//                   Select Workflows <span className="text-danger-600">*</span>
//                 </label>
//                 <CustomSelect
//   name="workflows"
//   value={selectedWorkflows.map((w) => ({
//     value: w.id,
//     label: w.name,
//   }))}
//   onChange={handleWorkflowSelect}
//   options={workflows}
//   placeholder="Search and select workflows..."
//   labelKey="name"
//   valueKey="id"
//   addNewLabel="Add New Workflow"
//   addNewRoute="/add-workflow"
//   isMulti={true}
//   isLoading={workflowsLoading}
// />
//                 {/* Selected Workflows Display */}
//                 {selectedWorkflows.length > 0 && (
//                   <div className="mt-2">
//                     <small className="text-muted">Selected workflows:</small>
//                     <div className="d-flex flex-wrap gap-1 mt-1">
//                       {selectedWorkflows.map((workflow) => (
//                         <span
//                           key={workflow.id}
//                           className="badge bg-primary d-flex align-items-center"
//                         >
//                           {workflow.name}
//                           <button
//                             type="button"
//                             className="btn-close btn-close-white ms-2"
//                             style={{ fontSize: "0.7em" }}
//                             onClick={() => handleWorkflowToggle(workflow)}
//                           ></button>
//                         </span>
//                       ))}
//                     </div>
//                   </div>
//                 )}
//               </div>
//             </div>

//             {/* Submit Button */}
//             <div className="d-flex align-items-center justify-content-center gap-3 mt-4">
//               <button
//                 type="submit"
//                 className="btn btn-primary-600 border border-primary-600 text-md px-56 py-12 radius-8"
//                 disabled={
//                   assignLoading ||
//                   !selectedClient ||
//                   selectedWorkflows.length === 0
//                 }
//               >
//                 {assignLoading ? "Assigning..." : "Assign Workflows"}
//               </button>
//             </div>
//           </form>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default WorkFlowAssignListLayer;

import React, { useState, useEffect } from "react";
import { apiCall } from "../Apis/apiCall";
import { useNavigate, useLocation } from "react-router-dom";
import Select from "react-select";
import LoadingComponent from "./ui/LoadingComponent";
import { handleApiResponse, handleCustomResponse } from "../utils/response";
import CustomSelect from "./ui/CustomSelect";
import ErrorAlert from "./ui/ErrorAlert";

const WorkFlowAssignListLayer = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [error, setError] = useState(null);

  // Client state
  const [allClients, setAllClients] = useState([]);
  const [clients, setClients] = useState([]);
  const [clientsLoading, setClientsLoading] = useState(false);
  const [clientSearch, setClientSearch] = useState("");
  const [selectedClient, setSelectedClient] = useState(null);

  // Workflow state
  const [allWorkflows, setAllWorkflows] = useState([]);
  const [workflows, setWorkflows] = useState([]);
  const [workflowsLoading, setWorkflowsLoading] = useState(false);
  const [workflowSearch, setWorkflowSearch] = useState("");
  const [selectedWorkflows, setSelectedWorkflows] = useState([]);
  const [preSelectedWorkflow, setPreSelectedWorkflow] = useState(null);

  // Assignment state
  const [assignLoading, setAssignLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(true);

  // Check for pre-selected workflow from navigation
  useEffect(() => {
    const navigationState = location.state;
    if (navigationState?.selectedWorkflow) {
      const { id, name } = navigationState.selectedWorkflow;
      setPreSelectedWorkflow({ id, name });
      setSelectedWorkflows([{ id, name }]);
    }
  }, [location]);

  // Fetch clients (only initial load)
  const fetchClients = async () => {
    try {
      setError(null);
      setClientsLoading(true);
      const endpoint = `/get-all-clients?search=&page=1&per_page=1000&sort_by=client_id&sort_order=desc&want_pagination=0`;

      const response = await apiCall("get", endpoint, null, navigate);

      if (response?.data?.success) {
        const clientList = response.data.data || [];
        setAllClients(clientList);
        setClients(clientList);

        const handleRes = response.data;
        handleApiResponse(handleRes, "success", "GET");
      } else {
        handleCustomResponse("error", "Failed to fetch clients");
      }
    } catch (error) {
      const handleErr = error.response?.data;
      handleApiResponse(handleErr, "Err", "GET");
      setError(true);
    } finally {
      setClientsLoading(false);
    }
  };

  // Fetch workflows (only initial load)
  const fetchWorkflows = async () => {
    try {
      setError(null);
      setWorkflowsLoading(true);
      const endpoint = `/get-all-workflows-bo?search=&page=1&per_page=1000&sort_by=workflow_id&sort_order=desc&want_pagination=0`;

      const response = await apiCall("get", endpoint, null, navigate);

      if (response?.data?.errorCode === 0) {
        const { data: workflowData } = response.data;

        const mappedWorkflows = workflowData.map((workflow) => ({
          id: workflow.workflow_id,
          name: workflow.workflow_name,
          description: workflow.description || "",
        }));
        setAllWorkflows(mappedWorkflows);
        setWorkflows(mappedWorkflows);

        // Ensure pre-selected workflow is included
        if (preSelectedWorkflow) {
          const workflowExists = mappedWorkflows.find(
            (w) => w.id === preSelectedWorkflow.id
          );
          if (workflowExists) {
            setSelectedWorkflows([preSelectedWorkflow]);
          }
        }

        const handleRes = response.data;
        handleApiResponse(handleRes, "success", "GET");
      } else {
        handleCustomResponse("error", "Failed to fetch workflows");
      }
    } catch (error) {
      const handleErr = error.response?.data;
      handleApiResponse(handleErr, "Err", "GET");
      setError(true);
    } finally {
      setWorkflowsLoading(false);
    }
  };

  // Initial load
  useEffect(() => {
    const loadInitialData = async () => {
      setPageLoading(true);
      await Promise.all([fetchClients(), fetchWorkflows()]);
      setPageLoading(false);
    };

    loadInitialData();
  }, []);

  // Local client search handler
  const handleClientSearch = (value) => {
    setClientSearch(value);

    if (!value.trim()) {
      setClients(allClients);
      return;
    }

    const filtered = allClients.filter((client) =>
      (client.client_name || client.name || "")
        .toLowerCase()
        .includes(value.toLowerCase())
    );
    setClients(filtered);
  };

  // Local workflow search handler
  const handleWorkflowSearch = (value) => {
    setWorkflowSearch(value);

    if (!value.trim()) {
      setWorkflows(allWorkflows);
      return;
    }

    const filtered = allWorkflows.filter((workflow) =>
      workflow.name.toLowerCase().includes(value.toLowerCase())
    );
    setWorkflows(filtered);
  };

  // Client select handler
  const handleClientSelect = (selectedOption) => {
    const client = clients.find((c) => c.client_id === selectedOption?.value);
    setSelectedClient(client);
  };

  // Workflow select handler
  const handleWorkflowSelect = (selectedOptions) => {
    const selected = selectedOptions
      ? selectedOptions.map((option) => ({
          id: option.value,
          name: option.label,
        }))
      : [];

    // Prevent removing pre-selected workflow
    if (preSelectedWorkflow && selected.length === 0) {
      const workflowExists = workflows.find(
        (w) => w.id === preSelectedWorkflow.id
      );
      if (workflowExists) {
        setSelectedWorkflows([preSelectedWorkflow]);
        return;
      }
    }

    setSelectedWorkflows(selected);
  };

  // Toggle workflow for badge removal
  const handleWorkflowToggle = (workflow) => {
    // Prevent removing pre-selected workflow
    if (preSelectedWorkflow && workflow.id === preSelectedWorkflow.id) {
      return;
    }

    setSelectedWorkflows((prev) => {
      const exists = prev.find((w) => w.id === workflow.id);
      if (exists) {
        return prev.filter((w) => w.id !== workflow.id);
      } else {
        return [...prev, workflow];
      }
    });
  };

  // Assign workflows
  const handleAssignWorkflows = async (e) => {
    e.preventDefault();

    if (!selectedClient) {
      handleCustomResponse("error", "Please select a client");
      return;
    }

    if (selectedWorkflows.length === 0) {
      handleCustomResponse("error", "Please select at least one workflow");
      return;
    }

    try {
      setAssignLoading(true);

      const payload = {
        client_id: selectedClient.client_id,
        workflow_ids: selectedWorkflows.map((w) => w.id),
      };

      const response = await apiCall(
        "POST",
        "/assign-workflows",
        payload,
        navigate
      );

      if (response.data?.success) {
        const handleRes = response.data;
        handleApiResponse(handleRes, "success", "POST");

        // Reset form
        setSelectedClient(null);
        setSelectedWorkflows([]);
        setPreSelectedWorkflow(null);

        // Navigate to workflow list after successful assignment
        setTimeout(() => {
          navigate("/workflow-assign");
        }, 1500);
      } else {
        handleCustomResponse("error", "Failed to assign workflows");
      }
    } catch (error) {
      const handleErr = error.response?.data;
      handleApiResponse(handleErr, "Err", "POST");
    } finally {
      setAssignLoading(false);
    }
  };

  // Client options
  const getClientOptions = () => {
    return clients.map((client) => ({
      value: client.client_id,
      label: client.client_name || client.name,
    }));
  };

  // Workflow options
  const getWorkflowOptions = () => {
    return workflows.map((workflow) => ({
      value: workflow.id,
      label: workflow.name,
    }));
  };

  // Show loading component while initial data loads
  if (pageLoading) {
    return <LoadingComponent />;
  }

  const clientOptions = getClientOptions();
  const workflowOptions = getWorkflowOptions();
  if (error) {
    return <ErrorAlert />;
  }
  return (
    <div className="p-4 p-md-3 p-sm-2">
      <div className="card shadow-sm">
        <div className="card p-3 p-sm-2 p-md-3">
          <form onSubmit={handleAssignWorkflows}>
            <div className="row g-20">
              {/* Client Selection */}
              <div className="col-md-6 mb-20">
                <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                  Select Client <span className="text-danger-600">*</span>
                </label>
                <CustomSelect
                  name="client"
                  value={
                    selectedClient
                      ? {
                          value: selectedClient.client_id,
                          label:
                            selectedClient.client_name || selectedClient.name,
                        }
                      : null
                  }
                  onChange={handleClientSelect}
                  options={clients}
                  placeholder="Search and select client..."
                  labelKey="client_name"
                  valueKey="client_id"
                  addNewLabel="Add New Client"
                  addNewRoute="/add-client"
                  isLoading={clientsLoading}
                />
              </div>

              {/* Workflow Selection */}
              <div className="col-md-6 mb-20">
                <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                  Select Workflows <span className="text-danger-600">*</span>
                </label>
                <CustomSelect
                  name="workflows"
                  value={
                    selectedWorkflows.length > 0
                      ? selectedWorkflows.map((w) => ({
                          value: w.id,
                          label: w.name,
                        }))
                      : preSelectedWorkflow
                      ? [
                          {
                            value: preSelectedWorkflow.id,
                            label: preSelectedWorkflow.name,
                          },
                        ]
                      : []
                  }
                  onChange={handleWorkflowSelect}
                  options={workflows}
                  placeholder={
                    preSelectedWorkflow
                      ? `${preSelectedWorkflow.name} is pre-selected. Add more or modify...`
                      : "Search and select workflows..."
                  }
                  labelKey="name"
                  valueKey="id"
                  addNewLabel="Add New Workflow"
                  addNewRoute="/add-workflow"
                  isMulti={true}
                  isLoading={workflowsLoading}
                />
                {/* Selected Workflows Display */}
                {selectedWorkflows.length > 0 && (
                  <div className="mt-2">
                    <small className="text-muted">
                      {preSelectedWorkflow
                        ? "Pre-selected from workflow page:"
                        : "Selected workflows:"}
                    </small>
                    <div className="d-flex flex-wrap gap-1 mt-1">
                      {selectedWorkflows.map((workflow) => (
                        <span
                          key={workflow.id}
                          className={`badge ${
                            workflow.id === preSelectedWorkflow?.id
                              ? "bg-success"
                              : "bg-primary"
                          } d-flex align-items-center`}
                        >
                          {workflow.name}
                          {workflow.id !== preSelectedWorkflow?.id && (
                            <button
                              type="button"
                              className="btn-close btn-close-white ms-2"
                              style={{ fontSize: "0.7em" }}
                              onClick={() => handleWorkflowToggle(workflow)}
                            ></button>
                          )}
                          {workflow.id === preSelectedWorkflow?.id && (
                            <span
                              className="ms-1"
                              style={{ fontSize: "0.7em" }}
                            >
                              (Pre-selected)
                            </span>
                          )}
                        </span>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* Submit Button */}
            <div className="d-flex align-items-center justify-content-center gap-3 mt-4">
              <button
                type="submit"
                className="btn btn-primary-600 border border-primary-600 text-md px-56 py-12 radius-8"
                disabled={
                  assignLoading ||
                  !selectedClient ||
                  selectedWorkflows.length === 0
                }
              >
                {assignLoading ? "Assigning..." : "Assign Workflows"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default WorkFlowAssignListLayer;
